<template>
  <component :is="node.tag" v-if="node.type === 'element'" v-bind="node.attrs">
    <ForumResponseBodyTextOutputNode
      v-for="(child, idx) in node.children"
      :key="idx"
      :node="child"
      :basic-mention="basicMention"
      :chat-id="chatId"
    />
  </component>
  <ForumResponseBodyTextOutputMention
    v-else-if="node.type === 'mention'"
    :basic="basicMention"
    :chat-id="chatId"
    :prospect-id="node.options?.prospectId"
    :user-id="node.options?.userId"
    :full-name="node.options?.fullName"
    :is-anonymous="node.options?.isAnonymous"
    :to-moderator="node.options?.toModerator"
    :anonymous-id="node.options?.anonymousId"
    :is-reply="node.options?.isReply"
  />
  <span v-else-if="node.type === 'text'">{{ node.value }}</span>
</template>

<script>
import ForumResponseBodyTextOutputMention from '@/components/pages/forum/response/body/text/ForumResponseBodyTextOutputMention.vue'

export default {
  name: 'ForumResponseBodyTextOutputNode',
  components: {
    ForumResponseBodyTextOutputMention,
    ForumResponseBodyTextOutputNode: null
  },
  props: {
    node: { type: Object, required: true },
    basicMention: { type: Boolean, default: true },
    chatId: { type: [Number, String], default: null }
  },
  created() {}
}
</script>
